import AyudaVentasDashboard from '@/components/ayudaventas/AyudaVentasDashboard'

export default function AyudaVentasPage() {
  return <AyudaVentasDashboard />
}
